<template>
    <v-layout column>

        <v-toolbar color="primary" dark>
            <v-btn icon @click="$emit('close')">
                <v-icon>close</v-icon>
            </v-btn>

            <v-toolbar-title class="no-selectable">{{(loginMode) ? $t("Login") : $t("Register")}}</v-toolbar-title>
        </v-toolbar>

        <v-container>
            <v-alert @logsucces="alert('logsucces')" outline style="text-align: left;" class="mb-3"
                :value="alert.visible"
                :type="alert.type" >
                {{alert.text}}
            </v-alert>

            <transition :name="(loginMode) ? 'slide-2' : 'slide'"  mode="out-in">
                <v-form key="2" v-if="loginMode">
                    <v-text-field prepend-icon="email" name="email" :label="$t('Email')" type="text" @keyup.enter.native="login" required v-model="email"></v-text-field>
                    <v-text-field prepend-icon="lock" name="password" :label="$t('Password')" type="password" @keyup.enter.native="login" required v-model="password"></v-text-field>
                    <div class="v-input v-input__control" style="margin-bottom: 10px;">
                        <forgot-password></forgot-password>
                    </div>


                    <v-btn color="primary" dark @click="login">{{$t('Sign In')}}</v-btn>
                    <v-btn v-if="!onlyLogin" color="primary" outline v-on:click="goRegister">
                        {{$t('Register')}}
                        <v-icon right light>arrow_forward</v-icon>
                    </v-btn>

                </v-form>
                <v-form key="1" ref="form" v-else>
                    <v-text-field prepend-icon="person" name="username" :label="$t('Username')" type="text" required v-model="usernameReg"></v-text-field>
                    <v-text-field prepend-icon="email" name="email" :label="$t('Email')" type="text" required v-model="emailReg"></v-text-field>
                    <v-text-field prepend-icon="lock" name="password" :label="$t('Password')" type="password" required v-model="passwordReg"></v-text-field>
                    <v-text-field prepend-icon="lock" name="passwordR" :label="$t('Repeat Password')" type="password" required v-model="passwordValReg"></v-text-field>

                    <v-btn color="primary" outline dark v-on:click="goLogin">
                        <v-icon left light>arrow_back</v-icon>
                        {{$t('Login')}}
                    </v-btn>
                    <v-btn color="primary" dark @click="register">{{$t('Register')}}</v-btn>
                </v-form>


            </transition>
        </v-container>

    </v-layout>
</template>

<script>
    import LocalRepository from '@/repositories/LocalRepository';
    import AuthRepository from "@/repositories/AuthRepository";
    import ForgotPassword from '@/components/ForgotPassword';

    import { VToolbar, VLayout, VToolbarTitle, VBtn, VIcon, VForm, VTextField, VContainer, VAlert } from 'vuetify/lib'

    export default {
        name: 'LoginDrawer',
        components: { VToolbar, VLayout, VToolbarTitle, VBtn, VIcon, VForm, VTextField, VContainer, VAlert, ForgotPassword},
        data () {
            return {
                // Alert
                alert: {},
                loginMode: true,
                // Login Inputs
                email: "",
                password: "",
                // Register Inputs
                usernameReg: "",
                emailReg: "",
                passwordReg: "",
                passwordValReg: "",
                force: false,
            }
        },
        props: {
            onlyLogin: Boolean,
        },
        created () {
            // Check token in url
            if (this.$route.params.token) {
                AuthRepository.getMe(this.$route.params.token)
                    .then((me) => {
                        this.emailReg = me.email;
                    })
            }
        },
        methods: {
            login() {
                AuthRepository.login(this.email, this.password)
                    .then((response) => {
                        if (response && response.data.token) {

                            // Save token
                            LocalRepository.set('token', response.data.token);

                            // Check if we have a token in header
                            if (this.$route.params.token) {
                                this.$router.push({name: 'home'});
                            }

                            // Login success
                            this.snakeSuccess(this.$t('Login succesfull.'));

                            // Socket login
                            if (response.data.id) {
                                this.$socket.emit('LOGIN', {id: response.data.id});
                            }

                            if (this.onlyLogin) {
                                // If only login, redirect to page
                                if (this.$route.params.hasOwnProperty('next')) {
                                    this.$router.push({path: this.$route.params.next.path});
                                } else {
                                    this.$router.push({name: 'home'});
                                }
                            } else {
                                // Close drawer and update user
                                this.$emit('close');
                                this.$root.$emit('clear-upload-form',{email:this.email});
                                AuthRepository.getMe().then(user => {
                                    if (user) this.$user = user;
                                })
                            }

                        } else {
                            this.alertError("Bad credentails!");
                        }
                    }).catch((error) =>{
                        this.alertError(error.response.data.message);
                    });
            },
            register() {
                if (this.passwordReg == this.passwordValReg) {
                    AuthRepository.register(this.usernameReg, this.emailReg, this.passwordReg, this.force)
                        .then((response) => {
                            if (response && response.data.token) {
                                LocalRepository.set('token', response.data.token);
                                this.$root.$emit('show-modal', {title: this.$t('Register'),message: this.$t('Thank you for registering!\nYou\'re almost done. Please click on the account confirmation link we just sent to ')+this.emailReg+this.$t('. Check your spam folder if you can\'t find it in the inbox. We hope you enjoy using WeLicense.'),type: '' });
                                this.$emit('close');
                            } else {
                                this.alertError("Bad credentails! ");
                            }
                        }).catch((error) => {
                            this.alertError(error.response.data.message);
                            if (error.response.data.force) {
                                this.force = true;
                            }
                        });
                } else {
                    this.alertError("Password don't match.");
                }
            },
            goLogin(options) {
                this.loginMode=true;
                if (options && options.email) {
                    this.email = options.email;
                    this.password = "";
                }
            },
            goRegister(options) {
                this.loginMode=false;
                if (options && options.email) {
                    this.emailReg = options.email;
                    this.passwordReg = "";
                    this.usernameReg = "";
                }
            },
            setEmail(mail) {
                this.email=mail;
            },
            alertSuccess(text) {
                this.alert = {
                    type: "success",
                    text: text,
                    visible: true
                }
            },
            alertError(text) {
                this.alert = {
                    type: "error",
                    text: text,
                    visible: true
                }
            },
            snakeSuccess(text){
                this.$root.$emit('show-snackbar', {message: text,color: 'success', timeout: 6000 });
            },
            snakeError(text){
                this.$root.$emit('show-snackbar', {message: text,color: 'error', timeout: 6000 });
            }
        }
    }
</script>

<style lang="scss">
    .slide-2-leave-active,
    .slide-2-enter-active,
    .slide-leave-active,
    .slide-enter-active {
        transition: 0.2s;
    }

    .slide-enter {
        transform: translate(100%, 0);
    }
    .slide-leave-to {
        transform: translate(-100%, 0);
    }

    .slide-2-enter {
        transform: translate(-100%, 0);
    }
    .slide-2-leave-to {
        transform: translate(100%, 0);
    }
</style>